<form class="form" [formGroup]="loginForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="contact">
          {{ "DATA.LABELS.WA_NUMBER" | translate }}
        </label>
        <tel-input
          formControlName="contact"
          [invalid]="f.contact.errors && f.contact.touched"
        ></tel-input>
        <div
          class="custom-error"
          *ngIf="f['contact'].touched && f['contact'].errors"
        >
          <span *ngIf="f.contact.value && f.contact.errors">
            {{ "DATA.ERRORS.INVALID_CONTACT_NUMBER" | translate }}
          </span>
          <span *ngIf="f['contact'].touched && f['contact'].value == null">
            {{ "DATA.ERRORS.WA_REQUIRED" | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <div class="d-flex justify-content-between">
          <label for="password">{{ "DATA.LABELS.PASSWORD" | translate }}</label>
          <a routerLink="../forgot-password">
            <small>{{ "DATA.LABELS.FORGOT_PASS" | translate }}</small>
          </a>
        </div>
        <password-control
          [control]="f['password']"
          placeholder="{{ 'DATA.PLACEHOLDERS.PASSWORD' | translate }}"
          id="password"
        ></password-control>
        <div
          class="custom-error"
          *ngIf="f['password'].touched && f['password'].errors"
        >
          <span *ngIf="f['password'].errors.required">
            {{ "DATA.ERRORS.PASSWORD_REQUIRED" | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <button
        type="submit"
        class="btn btn-primary btn-block"
        [disabled]="!loginForm.valid || isLoading"
      >
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          *ngIf="isLoading"
        ></span>
        <span class="mx-50 align-middle">
          {{ "DATA.LABELS.SIGN_IN" | translate }}
        </span>
      </button>
    </div>
  </div>
</form>
